export default "__VITE_ASSET__8fb15f1d__"